import { Navigate, Outlet } from 'react-router-dom'

export const PrivateRoute = ({ isAllowed, children, redirectTo, loading = false }) => {
  // No redirigir mientras está cargando la verificación de auth
  if (loading) {
    return null
  }

  if (!isAllowed) {
    if (redirectTo) return <Navigate to={redirectTo} />
    // return <LoginPage />
    return null
  }

  return children ?? <Outlet />
}
